import C from "action-types";
import { createReducer } from "utils/reducer";

const trackingImport = createReducer(
  {
    isFetching: false,
    accountNumberFailures: []
  },
  {
    [C.TRACKING.TRACKING_IMPORT_REQUEST]: () => ({
      isFetching: true,
      accountNumberFailures: []
    }),
    [C.TRACKING.TRACKING_IMPORT_SUCCESS]: () => ({
      isFetching: false,
      accountNumberFailures: []
    }),
    [C.TRACKING.TRACKING_IMPORT_FAILURE]: (_, { payload }) => ({
      isFetching: false,
      accountNumberFailures: payload
    })
  }
);

export default trackingImport;